import { FC, useCallback, useEffect, useMemo, useState } from "react";
import ModalPortal from "components-new/ModalPortal";
import AddDocument from "./AddDocument";
import EditTemplate from "./EditTemplate";
import Finish from "./Finish";
import { useAppSelector } from "toolkit/hooks";
import { directoryAPI } from "libs/apiClient/Directory";
import { DocumentPatternResponse } from "libs/apiClient/data-contracts";

interface CreateDocumentProps {
	file: DocumentPatternResponse | null;
	currentOrg: number | null;
	close: () => void;
	getData: () => void;
}

export interface IInitialUploadData {
	docxName: string;
	docxType: number;
	organizationId?: number;
	previousVer: string;
}
const CreateDocument: FC<CreateDocumentProps> = ({ file: document, getData, currentOrg, close }) => {
	const [step, setStep] = useState<"edit" | "add" | "finish">("edit");

	const [file, setFile] = useState<File>();

	const modalParams = useMemo(() => {
		const params: { handleClose: () => void; size: "md" | "lg" | "sm" | "sl"; title: string } = {
			handleClose: close,
			title: "",
			size: "md",
		};

		switch (step) {
			case "edit":
				params.title = "Настройка шаблона документа";
				params.size = "sm";
				break;
			case "add":
				params.title = "Прикрепление шаблона документа";
				params.size = "lg";
				break;
			case "finish":
				params.title = "Шаблон документа прикреплен!";
				params.size = "sm";
				break;
		}

		return params;
		//eslint-disable-next-line
	}, [step]);

	const profileId = useAppSelector((state) => state.profile.profile.id);

	const [uploadData, setUploadData] = useState<IInitialUploadData>({
		docxType: 0,
		previousVer: "",
		docxName: "",
	});

	useEffect(() => {
		setUploadData((prevState) => ({
			...prevState,
			docxType: document?.docxType.id || 0,
			...(currentOrg && currentOrg > 0 && { organizationId: currentOrg }),
		}));
	}, [document, profileId, currentOrg]);

	const [load, setLoad] = useState(false);

	const submit = useCallback(() => {
		setLoad(true);
		directoryAPI
			.docxTemplatesUpdateOrCreateTemplateByUploadCreate({
				params: uploadData,
				Template: file!,
			})
			.then(() => {
				getData();
				close();
				setLoad(false);
			});
		//eslint-disable-next-line
	}, [uploadData, file]);
	return (
		<ModalPortal {...modalParams} outSide={false}>
			{step === "edit" && (
				<EditTemplate close={close} data={uploadData} setData={setUploadData} nextStep={() => setStep("add")} />
			)}
			{step === "add" && <AddDocument setFile={setFile} nextStep={() => setStep("finish")} />}
			{step === "finish" && (
				<Finish
					close={close}
					nextStep={submit}
					load={load}
					fileName={file ? file.name : "Не удалось получить имя файла"}
				/>
			)}
		</ModalPortal>
	);
};

export default CreateDocument;
